module.exports = __webpack_public_path__ + "img/graphy-2.1abc2d8c.webp";